/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --border-top: var(--nve-ref-border-width-sm) solid var(--nve-ref-border-color);
  --padding: var(--nve-ref-size-400);
  --gap: var(--nve-ref-space-sm);
  display: block;
  width: 100%;
  margin-block-start: auto;
}

[internal-host] {
  border-top: var(--border-top);
  padding: var(--padding);
  gap: var(--gap);
  display: flex;
  justify-content: end;
}
